import React from "react";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
const DevelopersInfo = () => (
    <div className="developers-info" style={{ textAlign: "center", fontSize: "1rem" }}>
        <hr />
        <div>
            <strong>Website Developed By:</strong>
            <div>Priyanka Senger</div>
            <div className="social-icons-head" style={{ listStyleType: "none", padding: 0, display: "inline-flex", gap: "10px", margin: "10px 0" }}>
            <li>
                <a href="https://www.linkedin.com/in/priyanka-senger-878aa5184/" target="_blank">
                    <LinkedInIcon className="social-icon" />
                </a>
            </li>
            </div>
            <div>Contact: +91- 80764 63667</div>
        </div>
        <hr />
    </div>
);

export default DevelopersInfo;
